export function mapSetBearing(bearing, options) { return this._animateCamera(this.getPitch(), bearing, options); }
